import { SoapUtils } from "../../../utils/SoapUtils";

export interface CustomView {
    id?:            string;
    treeHandle?:    string;
    created?:       string;
    createdBy?:     string;
    modified?:      string;
    modifiedBy?:    string;
    nameId?:        string;
    name?:          string;
    NAME?:          Name;
    definition?:    string;
    level?:         string;
    assignTo?:      string;
    moduleId?:      string;
    applicationId?: string;
    priority?:      string;
}

export interface Name {
    TRANSLATION?: Translation[];
}

export interface Translation {
    id?:    string;
    short?: string;
    text?:  string;
}

export function toCustomView(customView: CustomView): string {
    var xml = '';
    xml += '<CUSTOM_VIEW>';
    xml += SoapUtils.makeNode(customView.id, 'id');
    xml += SoapUtils.makeNode(customView.treeHandle, 'treeHandle');
    xml += SoapUtils.makeNode(customView.created, 'created');
    xml += SoapUtils.makeNode(customView.createdBy, 'createdBy');
    xml += SoapUtils.makeNode(customView.modified, 'modified');
    xml += SoapUtils.makeNode(customView.modifiedBy, 'modifiedBy');
    xml += SoapUtils.makeNode(customView.nameId, 'nameId');
    xml += SoapUtils.makeNode(customView.name, 'name');
    if(customView.NAME) {
        var nameXml = '<NAME>';
        if(customView.NAME.TRANSLATION) {
            for(let translation of customView.NAME.TRANSLATION) {
                nameXml += '<TRANSLATION>';
                nameXml += SoapUtils.makeNode(translation.id, 'id');
                nameXml += SoapUtils.makeNode(translation.short, 'short');
                nameXml += SoapUtils.makeNode(translation.text, 'text');
                nameXml += '</TRANSLATION>';
            }
        }
        nameXml += '</NAME>';
        xml += nameXml;
    }
    xml += SoapUtils.makeNode(customView.definition, 'definition');
    xml += SoapUtils.makeNode(customView.level, 'level');
    xml += SoapUtils.makeNode(customView.assignTo, 'assignTo');
    xml += SoapUtils.makeNode(customView.moduleId, 'moduleId');
    xml += SoapUtils.makeNode(customView.applicationId, 'applicationId');
    xml += SoapUtils.makeNode(customView.priority, 'priority');
    xml += '</CUSTOM_VIEW>';
    return xml;
}